const policy = 
`<p>欢迎使用杭州珍炫科技有限公司提供的服务。为使用杭州珍炫科技有限公司的服务，您应当阅读并遵守《杭州珍炫科技有限公司用户注册协议》和《杭州珍炫科技有限公司隐私政策》。本协议是用户与杭州珍炫科技有限公司之间的法律协议，是用户注册杭州珍炫科技有限公司平台账号和/或使用杭州珍炫科技有限公司服务时使用的通用条款。请您务必审慎阅读、充分理解各条款内容，您不应当以杭州珍炫科技有限公司未对本协议以合理方式提醒用户注意或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。除非您已阅读并接受本协议所有条款，否则您无权使用杭州珍炫科技有限公司提供的服务。您使用杭州珍炫科技有限公司的服务即视为您已阅读并同意上述协议的约束。</p>
<div class="bold">
  <p>本隐私政策（以下简称“本政策”）适用于杭州珍炫科技有限公司的所有相关服务。在使用杭州珍炫科技有限公司各项服务前，请您务必仔细阅读并透彻理解本政策，并做出您认为适当的选择。依照相关法律法规规定及监管要求，或为满足用户身份真实核验、保障系统和服务安全及其他特定服务功能等需要，我们可能需要您提供真实身份信息（例如姓名、电话号码、身份证、营业执照）、生物识别信息（静态或动态）及其他身份信息以完成身份认证。如果您不提供上述信息，我们将不能向您提供相关的功能及服务。一旦您开始使用杭州珍炫科技有限公司的各项服务，即表示您已充分理解并同意本政策。需要提醒您注意，本隐私权保护政策仅适用于我们所收集的信息。</p>
  <p>本政策将帮助您了解以下内容：</p>
  <p>1、我们如何收集和使用您的个人信息</p>
  <p>2、我们如何使用Cookie</p>
  <p>3、我们如何共享、转让、公开披露您的个人信息</p>
  <p>4、我们如何保护您的个人信息</p>
  <p>5、您的权利</p>
  <p>6、本政策如何更新</p>
  <p>7、如何联系我们。</p>
  <p>相关术语及定义</p>
  <p>1、杭州珍炫科技有限公司：指杭州珍炫科技有限公司及其子网站、客户端或对网站享有所有权或运营权的主体。</p>
  <p>2、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
  <p>3、收集：指获得对个人信息的控制权的行为，包括由个人信息主体主动提供、通过与个人信息主体交互或记录个人信息主体行为等自动采集，以及通过共享、转让、搜集公开信息间接获取等方式。</p>
  <p>4、删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
  <p>5、公开披露：指向社会或不特定人群发布信息的行为。</p>
  <p>6、转让：指将个人信息控制权由一个控制者向另一个控制者转移的过程。</p>
  <p>7、共享：指个人信息控制者向其他控制者提供个人信息，且双方分别对个人信息拥有独立控制权的过程。</p>
  <p>一、我们如何收集和使用您的个人信息</p>
  <p>（一）我们如何收集您的个人信息</p>
  <p>您在使用杭州珍炫科技有限公司提供的服务时，为了更好地实现您的目的，我们可能收集和使用您的个人信息，如您拒绝，您可能无法注册账号或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。收集的情形包括：</p>
  <p>1、您提供的信息，包括但不限于：</p>
  <p>(1)您在注册杭州珍炫科技有限公司账号时提供的信息。例如：手机号、电子邮件、昵称等。</p>
  <p>(2)您在使用杭州珍炫科技有限公司的过程中向我们提供的信息。</p>
  <p>2、在您使用服务的过程中获取的信息，包括但不限于：</p>
  <p>(1)在使用与地理位置相关的服务时的地理定位信息；</p>
  <p>(2)在使用浏览器或者移动应用时的浏览器、移动设备信息、唯一应用编程序号、IP地址等;</p>
  <p>(3)在使用服务的过程中产生的日志信息，例如访问页面URL、搜索词等;</p>
  <p>(4)在使用第三方账号登录时的账号头像。</p>
  <p class="none">（二）我们如何使用您的个人信息</p>
  <p class="none">1、我们会在法律法规要求或杭州珍炫科技有限公司相关服务条款、软件许可用户注册协议约定的情况下因如下目的使用您的个人信息：</p>
  <p class="none">(1)向您提供您使用的各项服务，并维护、改进这些服务。</p>
  <p class="none">(2)向您推荐您可能感兴趣的内容，包括但不限于向您发出产品和服务信息，如您不希望接收上述信息，可通过相应的退订功能进行取消接收。</p>
  <p class="none">(3)我们可能会将来自某项服务的个人信息、交易信息与来自其他服务所获得的信息结合起来，进行综合统计、分析或加工等处理，以便为您提供更加个性化的服务。</p>
  <p class="none">(4)储存并维护用户信息以用于运营业务或履行法律义务。</p>
  <p class="none">(5)经您同意的其他目的。<span></span></p>
  <p class="none">2、需要提醒您注意，以下情形中，使用您的个人信息无需您的同意：</p>
  <p class="none">(1)与国家安全、国防安全直接相关的。</p>
  <p class="none">(2)与公共安全、公共卫生、重大公共利益直接相关的。</p>
  <p class="none">(3)与犯罪侦查、起诉、审判和判决执行等直接相关的。</p>
  <p class="none">(4)出于维护个人信息主体或其他个人的生命、财产等重大合法权益，情况紧急，无法及时与您取得联系或但其他无法及时又取得很难得您到本人同意的情形的。</p>
  <p class="none">(5)用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</p>
  <p class="none">(6)法律法规规定的其他情形。</p>
  <p class="none"><span></span></p>
  <p>二、我们如何使用Cookie</p>
  <p>使用Cookie能帮助您实现您的联机体验的个性化，您可以接受或拒绝Cookie，大多数Web浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie。Cookie不会跟踪个人信息。</p>
  <p>当您注册杭州珍炫科技有限公司时，杭州珍炫科技有限公司亦会使用Cookie。在这种情况下，杭州珍炫科技有限公司会收集并存储有用信息，当您再次访问杭州珍炫科技有限公司时，我们可辨认您的身份。来自杭州珍炫科技有限公司的Cookie只能被杭州珍炫科技有限公司读取。如果您的浏览器被设置为拒绝Cookie，您仍然能够访问杭州珍炫科技有限公司的大多数网页。</p>
  <p>三、我们如何共享、转让、公开披露您的个人信息</p>
  <p>（一）共享</p>
  <p>尊重用户个人隐私是杭州珍炫科技有限公司的一项基本原则。除以下情形外，我们不会与任何公司、组织和个人分享您的个人信息：</p>
  <p>1.我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
  <p>2.与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务，我们仅会出于本隐私政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。</p>
  <p>（二）转让</p>
  <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
  <p>在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
  <p>（三）公开披露</p>
  <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
  <p  class="none">基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。<span></span></p>
  <p>四、我们如何保护您的个人信息</p>
  <p>（一）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
  <p>（二）互联网并非绝对安全的环境，而且电子邮件、即时通讯及与其他杭州珍炫科技有限公司用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
  <p>（三）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
  <p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
  <p>五、您的权利</p>
  <p>无论您何时使用杭州珍炫科技有限公司，我们都会尽一切可能保证您可以顺利访问自己的账户信息。如果这些信息有误，我们会努力提供各种方式来让您快速更新或删除账户内信息（除非我们出于法律法规等方面的原因而必须保留这些信息）。按照法律及通行做法，为了使您拥有充分的能力保障您的隐私和安全，您拥有如下权利：</p>
  <p>（一）访问您的个人信息</p>
  <p>除法律法规规定外，您有权随时访问您的个人信息。主要包括以下信息：</p>
  <p>检索信息：您可以在检索时，访问或使用清空功能，清除您的检索历史记录。</p>
  <p>如果您无法通过上述链接及方式访问，您可以随时联系我们，我们将尽快回复您的请求。</p>
  <p>（二）更正您的个人信息</p>
  <p>当您发现您所填写的或者我们处理的关于您的个人信息有错误时，您有权自行更正。当您无法自行更正时，您可以随时联系我们，我们将尽快回复您的更正请求。</p>
  <p>（三）删除您的个人信息</p>
  <p>除法律法规规定外，您有权随时自行删除或者联系我们删除您的信息。在以下情形中，您可以向我们提出删除个人信息的请求：</p>
  <p>1、我们处理个人信息的行为违反法律法规的。</p>
  <p>2、我们收集、使用您的个人信息，却未征得您的同意。</p>
  <p>3、我们处理个人信息的行为违反了与您的约定。</p>
  <p>4、您不再使用我们的产品或服务，或您注销了账号。</p>
  <p>5、我们不再为您提供产品或服务。</p>
  <p>（四）注销／删除账号</p>
  <p>您可以选择注销／删除杭州珍炫科技有限公司账号，账号被注销／删除后将不可恢复。除法律法规另有规定的情况之外，您的个人信息将被删除或注销处理，建议您做好备份。</p>
  <p>（五）响应您的上述请求</p>
  <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
  <p>我们将尽快做出答复。如您不满意，还可以通过以下途径联系我们：发送邮件到zhanglx@zhaixingshe.com。对于那些无端重复、需要过多技术手段(例如，需要开发新系统或从根本上改变现行惯例)、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
  <p  class="none">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
  <p  class="none">1、与国家安全、国防安全直接相关的。</p>
  <p class="none">2、与公共安全、公共卫生、重大公共利益直接相关的。</p>
  <p class="none">3、与犯罪侦查、起诉、审判和判决执行等直接相关的。</p>
  <p class="none">4、有充分证据表明您存在主观恶意或滥用权利的。</p>
  <p class="none">5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
  <p class="none">6、涉及商业秘密的。</p>
  <p><span></span></p>
  <p>六、本政策如何更新</p>
  <p>我们的隐私政策可能变更。</p>
  <p>通常情况下，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布或者以其他方式通知您对本政策所做的任何变更，对于重大变更，我们还会提供更为显著的通知。在此情况下，若您选择继续使用我们的服务，即表示同意受经修订的本政策的约束。</p>
  <p>本政策所指的重大变更包括但不限于：</p>
  <p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等。</p>
  <p>2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等。</p>
  <p>3、您参与个人信息处理方面的权利及其行使方式发生重大变化。</p>
  <p>4、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。</p>
  <p>5、个人信息安全影响评估报告表明存在高风险时。</p>
  <p>我们还会将本政策的旧版本存档，供您查阅。</p>
  <p>七、如何联系我们</p>
  <p>如果您对本隐私政策有任何疑问、意见或建议，可以致电15658178656联系我们。一般情况下，我们将在十五天内回复。</p>
  <p>如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您可以通过向杭州珍炫科技有限公司实际运营者所在地有管辖权的人民法院提起诉讼解决。</p>
  <p class="none">再次郑重提示并说明：请您一定认真、仔细阅读《杭州珍炫科技有限公司用户注册协议》和《杭州珍炫科技有限公司隐私政策》各项内容！尤其应着重了解特别标注部分的内容！若您已全部知悉，并理解了《杭州珍炫科技有限公司用户注册协议》和《杭州珍炫科技有限公司隐私政策》各项内容，请点选《已阅读并同意<用户注册服务协议>、<隐私政策>》！</p>
</div>
`
export default policy